import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper is-danger p-3 is-radius-4" }
const _hoisted_2 = { class: "is-flex is-justify-content-space-between is-align-items-center mb-3" }
const _hoisted_3 = { class: "has-text-danger" }
const _hoisted_4 = { class: "bold-text mb-2" }
const _hoisted_5 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "chip has-background-danger py-1 px-2 is-radius-5 is-size-7" }, "Quiz Failed", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.attemptsCount) + " of " + _toDisplayString(_ctx.quizMaxAttempts) + " attempts used", 1)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.quizName) + " Failed ", 1),
    _createElementVNode("div", _hoisted_5, "You scored " + _toDisplayString(_ctx.currentQuizScore) + "% with " + _toDisplayString(_ctx.correctAnswersCount) + " of " + _toDisplayString(_ctx.questionsPerQuiz) + " questions answered correctly (or partially).", 1),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "button is-danger is-outlined is-fullwidth",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openReview && _ctx.openReview(...args)))
      }, "Review Your Answers")
    ])
  ]))
}